import React from 'react';
import { referenceProjects } from '../data/mock';
import { Card, CardContent } from './ui/card';
import { Battery, Sun, Zap, MapPin } from 'lucide-react';

const ReferenceSection = () => {
  return (
    <section id="referenzen" className="py-24 bg-gradient-to-b from-slate-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 bg-sun-blue/10 text-sun-blue rounded-full text-sm font-semibold mb-4">
            Referenzprojekte
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 mb-6">
            Erfolgreich realisierte
            <span className="text-sun-orange"> Anlagen</span>
          </h2>
          <p className="text-lg text-slate-600 max-w-3xl mx-auto">
            Überzeugen Sie sich von unserer Arbeit. Hier sehen Sie ausgewählte 
            Projekte aus unserer Region.
          </p>
        </div>

        {/* Project Cards */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {referenceProjects.map((project) => (
            <Card
              key={project.id}
              className="group overflow-hidden border-0 shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-3 bg-white rounded-2xl"
            >
              {/* Project Image */}
              <div className="relative h-64 overflow-hidden">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 via-slate-900/20 to-transparent" />
                
                {/* Location Badge */}
                <div className="absolute top-4 left-4 flex items-center gap-1.5 bg-white/90 backdrop-blur-sm px-3 py-1.5 rounded-full">
                  <MapPin className="w-3.5 h-3.5 text-sun-orange" />
                  <span className="text-xs font-medium text-slate-700">{project.location}</span>
                </div>
                
                {/* Project Title */}
                <div className="absolute bottom-4 left-4 right-4">
                  <h3 className="text-2xl font-bold text-white mb-2">{project.title}</h3>
                  <p className="text-white/80 text-sm line-clamp-2">{project.description}</p>
                </div>
              </div>
              
              {/* Project Stats */}
              <CardContent className="p-6">
                <div className="grid grid-cols-3 gap-4">
                  <div className="text-center group/stat">
                    <div className="w-12 h-12 mx-auto mb-3 bg-sun-orange/10 rounded-xl flex items-center justify-center group-hover/stat:bg-sun-orange group-hover/stat:scale-110 transition-all duration-300">
                      <Sun className="w-6 h-6 text-sun-orange group-hover/stat:text-white transition-colors" />
                    </div>
                    <div className="text-xl font-bold text-slate-900">{project.pvSize}</div>
                    <div className="text-xs text-slate-500 mt-0.5">PV-Leistung</div>
                  </div>
                  <div className="text-center group/stat">
                    <div className="w-12 h-12 mx-auto mb-3 bg-sun-blue/10 rounded-xl flex items-center justify-center group-hover/stat:bg-sun-blue group-hover/stat:scale-110 transition-all duration-300">
                      <Battery className="w-6 h-6 text-sun-blue group-hover/stat:text-white transition-colors" />
                    </div>
                    <div className="text-xl font-bold text-slate-900">{project.batterySize}</div>
                    <div className="text-xs text-slate-500 mt-0.5">Speicher</div>
                  </div>
                  <div className="text-center group/stat">
                    <div className="w-12 h-12 mx-auto mb-3 bg-green-100 rounded-xl flex items-center justify-center group-hover/stat:bg-green-500 group-hover/stat:scale-110 transition-all duration-300">
                      <Zap className="w-6 h-6 text-green-600 group-hover/stat:text-white transition-colors" />
                    </div>
                    <div className="text-xl font-bold text-green-600">{project.autonomyRate}</div>
                    <div className="text-xs text-slate-500 mt-0.5">Autarkie</div>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ReferenceSection;
